import creator1 from "../assets/Creator1.png";
import creator2 from "../assets/Creator2.png";
import creator3 from "../assets/Creator3.png";
import creator4 from "../assets/Creator4.png";
import creator5 from "../assets/Creator5.png";
import creator6 from "../assets/Creator6.png";
import creator7 from "../assets/Creator7.png";
import creator8 from "../assets/Creator8.png";

const creatorImages = [
  { src: creator1, alt: "EfyaNobi – 2.7M followers" },
  { src: creator2, alt: "Creator 2" },
  { src: creator3, alt: "Creator 3" },
  { src: creator4, alt: "Creator 4" },
  { src: creator5, alt: "Creator 5" },
  { src: creator6, alt: "Creator 6" },
  { src: creator7, alt: "Creator 7" },
  { src: creator8, alt: "Calvinperbi – 5.3M followers" },
];

const CreatorsSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32 overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-[30px] lg:leading-tight xl:text-[36px] 2xl:text-[clamp(42px,3vw,62px)] font-bold leading-tight text-black max-w-[900px] mx-auto">
            Creators with large audiences are already creating on Luupli
          </h2>
          <p className="mt-4 lg:mt-4 xl:mt-5 2xl:mt-6 text-sm sm:text-base lg:text-[15px] xl:text-[17px] 2xl:text-[clamp(18px,2vw,26px)] leading-relaxed text-black">
            Big creators join for collaboration. Emerging creators stay because
            it works
          </p>
        </div>
      </div>

      <div className="mt-10 md:mt-14 lg:mt-16 xl:mt-20 relative">
        <div className="creators-scroll flex gap-[10px] lg:gap-4 xl:gap-6 w-max animate-scroll-left">
          {[...creatorImages, ...creatorImages].map((creator, i) => (
            <img
              key={i}
              src={creator.src}
              alt={creator.alt}
              className="h-[280px] sm:h-[340px] md:h-[400px] lg:h-[440px] xl:h-[471px] w-auto object-contain rounded-[33px] drop-shadow-[0_27.5px_27.5px_rgba(0,0,0,0.05)] shrink-0"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CreatorsSection;
